<template>
  <div class="auto-com">
    <label class="text">{{$t('supervise.fenceCenter')}}:</label>
    <input class="input" id='map-auto-complete' v-model="circle.address" type='text'>
    <label class="text" style="margin-left: 10px">{{$t('supervise.radius')}}:</label>
    <input class="input" v-model.number="circle.radius" @blur="onRadiusChange" style="width: 100px" type='text'>
    <!-- <span style="margin-left: 10px">米</span> -->
    <!-- <div id="searchResultPanel" style="border:1px solid #C0C0C0; width:150px; height:auto; display:none;"></div> -->
    <!-- {{circle}} -->
  </div>
</template>
<script>
export default {
  name: 'map-auto-complete',
  props: {
    map: {
      required: true
    },
    circle: {
      required: true,
      type: Object
    }
  },
  model: {
    event: 'circleChange',
    prop: 'circle'
  },
  data () {
    return {
      // center: this.circle.address,
      // radius: this.circle.radius,
      // centerPoint: ''
    }
  },
  methods: {
    init () {
      // 创建一个自动完成对象
      let ac = new BMap.Autocomplete(
        {
          input : 'map-auto-complete',
          location : this.map
        }
      )
      // console.log(ac)
      // 鼠标放在下拉列表上的事件
      ac.addEventListener('onhighlight', (e) => {  
        // console.log(e)
        let str = ''
        let _value = e.fromitem.value
        let value = ''
        if (e.fromitem.index > -1) {
          value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business
        }    
        str = 'FromItem<br />index = ' + e.fromitem.index + '<br />value = ' + value
        
        value = ''
        if (e.toitem.index > -1) {
          _value = e.toitem.value
          value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business
        }    
        str += '<br />ToItem<br />index = ' + e.toitem.index + '<br />value = ' + value
        // this.G('searchResultPanel').innerHTML = str
      }) 
      let myValue
      ac.addEventListener("onconfirm", (e) => {   //鼠标点击下拉列表后的事件
        // console.log(e)
        let _value = e.item.value
        myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business
        // this.G("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue
        this.circle.address = myValue
        this.setPlace(myValue)
      })
    },
    G (id) {
      return document.getElementById(id)
    },
    setPlace (myValue) {
      //清除地图上所有覆盖物
      // this.map.clearOverlays()    
      let myFun = () => {
        let pp = local.getResults().getPoi(0).point    //获取第一个智能搜索的结果
        this.map.setCenter(pp)
        // this.map.addOverlay(new BMap.Marker(pp)) 
        // 发送事件
        // if ()
        // this.centerPoint = pp
        // this.center = myValue
        // this.circle.address = myValue
        this.circle.center = pp
        // this.circle.radius = this.radius
        this.$emit('circleChange', this.circle)
      }
      let local = new BMap.LocalSearch(this.map, { //智能搜索
        onSearchComplete: myFun
      })
      local.search(myValue)
    },
    onRadiusChange () {
      // this.circle.center = this.centerPoint
      // this.circle.radius = this.radius
      this.$emit('circleChange', this.circle)
    }
  },
  mounted () {
    // console.log(this.circle)
    this.init()
  }
}
</script>
<style lang='less' scoped>
@import '../../theme/color.less';
.auto-com {
  width: 540px;
  background: @component-background;
  border-radius: 5px;
  position: relative;
  left: 230px;
  top: -490px;
  // height: 44px;
  border: .5px solid @primary-color;
  padding: 5px;
  box-sizing: border-box;
  .text {
    margin-right: 10px;
  }
  .input {
    appearance: none;
    width: 250px;
    background: rgba(255, 255, 255, 0.568);
    border-radius: 5px;
    border:1px solid #c8cccf;
    color:#6a6f77;
    height: 30px;
    // line-height: 44px;
    &:focus {
      border:1px solid @primary-color;
    }
  }
}
</style>
